<template>
  <div v-loading="loading">
    <el-row style="margin-top:10px">
      <el-col>
        <el-form ref="searchForm" v-model="searchForm" :inline="true" @keyup.enter.native="handleSearch">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.productName"></el-input>
          </el-form-item>
          <el-form-item label="产品编码">
            <el-input size="medium" v-model="searchForm.productCode"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" style="margin-left:20px" @click="handleSearch" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="addProduct(scope.row)">上架</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="addProductDialog" title="上架商品" @close="close" width="600px" center :inline="true">
      <el-form ref="addForm" v-model="addForm">
        <el-form-item label="产品代码：" prop="INNER_CODE" :label-width="formLabelWidth">
          <el-input v-model="addForm.INNER_CODE" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品名称：" prop="NAME" :label-width="formLabelWidth">
          <label slot="label">商品名称：</label>
          <el-input v-model="addForm.NAME" disabled></el-input>
        </el-form-item>
        <el-form-item label="单位：" prop="TYPE_UNIT" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <el-input v-model="addForm.TYPE_UNIT" disabled></el-input>
        </el-form-item>
        <div v-if="userPriceType == 1">
          <el-form-item label="当期价格：" :label-width="formLabelWidth">
            <el-input v-model="addForm.CURRENT_PRICE" @input="getAddPriceWithoutTax"></el-input>
          </el-form-item>
          <el-form-item label="当期不含税价格：" :label-width="formLabelWidth">
            <el-input v-model="addForm.PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item>
          <el-form-item label="下期价格：" :label-width="formLabelWidth">
            <el-input v-model="addForm.NEXT_PRICE" @input="getAddNextPriceWithoutTax"></el-input>
          </el-form-item>
          <el-form-item label="下期不含税价格：" :label-width="formLabelWidth">
            <el-input v-model="addForm.NEXT_PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item>
          <el-form-item label="生效日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="addForm.NEXT_EFFECTIVE_DATE" align="right" type="date" @change="selectData" placeholder="选择日期"
              value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="单价：" :label-width="formLabelWidth">
            <el-input v-model="addForm.PRICE" @input="getAddPriceWithoutTax"></el-input>
          </el-form-item>
          <el-form-item label="不含税单价：" :label-width="formLabelWidth">
            <el-input v-model="addForm.PRICE_WITHOUT_TAX" disabled></el-input>
          </el-form-item>
          <el-form-item label="开始日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="addForm.START_DAY" align="right" type="date" @change="selectData" placeholder="选择日期" value-format="yyyy-MM-dd"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期：" :label-width="formLabelWidth">
            <el-date-picker v-model="addForm.END_DAY" align="right" type="date" @change="selectData" placeholder="选择日期" value-format="yyyy-MM-dd"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="是否为缺省：" prop="BE_DEFAULT" :label-width="formLabelWidth" v-if="userPriceType == 1">
          <el-radio v-model="addForm.BE_DEFAULT" label="0">否</el-radio>
          <el-radio v-model="addForm.BE_DEFAULT" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProductDialog = false">取 消</el-button>
        <el-button @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryNewFun, putAway } from 'api/systemSetting';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      loading: false,
      TSVisible: false,
      loading1: false,
      loadSearch: false,
      tableData: [],
      searchForm: {
        productCode: '',
      },
      addForm: {},
      currentPage: 1,
      pageSize: 30,
      totalCount: 0,
      firstClass: [],
      twoClass: [],
      addProductDialog: false,
      formLabelWidth: '140px',
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
  methods: {
    handleCurrentChange(e) {
      this.handleSearch();
    },
    // -------------------------筛选数据
    handleSearch() {
      if (!this.searchForm.productName && !validation.产品编码验证(this.searchForm.productCode)) {
        this.$message.show({ text: '请输入正确的产品编码或商品名称', type: 'warning' });
        return false;
      }
      const params = {
        SUPPLIER_ID: sessionStorage.getItem('supplierId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        PRICE_MODE: this.userPriceType,
      };
      if (this.searchForm.productName) {
        params.PRODUCT_NAME = this.searchForm.productName;
      }
      if (this.searchForm.productCode) {
        params.PRODUCT_CODE = this.searchForm.productCode;
      }
      this.loadSearch = true;
      queryNewFun(params).then((res) => {
        if (res[0].TOTAL === 0) {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = res[0].list;
          this.totalCount = res[0].TOTAL;
        }
        this.loadSearch = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loadSearch = false;
      });
    },
    addProduct(row) {
      this.addProductDialog = true;
      this.addForm = {
        ...row,
        PRICE_WITHOUT_TAX: '0.00',
        NEXT_PRICE_WITHOUT_TAX: '0.00',
      };
    },
    selectData(e) {
      this.addForm.NEXT_EFFECTIVE_DATE = e;
    },
    // -------------------------------------------------上架产品
    submit() {
      if (this.userPriceType == 1) {
        if (!validation.价格正数0验证(this.addForm.CURRENT_PRICE) || !validation.价格正数0验证(this.addForm.NEXT_PRICE)) {
          this.$message.show({ text: '请输入正确的当前价格和下期价格', type: 'warning' });
          return false;
        }
      } else {
        if (!validation.价格正数0验证(this.addForm.PRICE) || !this.addForm.START_DAY || !this.addForm.END_DAY) {
          this.$message.show({ text: '数据输入有误', type: 'warning' });
          return false;
        }
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            PRODUCT_CODE: this.addForm.INNER_CODE,
            PRICE_MODE: this.userPriceType,
          };
          if (this.userPriceType == 2) {
            data.PRICE = this.addForm.PRICE;
            data.START_DAY = this.addForm.START_DAY;
            data.END_DAY = this.addForm.END_DAY;
          } else {
            data.CURRENT_PRICE = this.addForm.CURRENT_PRICE;
            data.NEXT_PRICE = this.addForm.NEXT_PRICE;
            data.NEXT_EFFECTIVE_DATE = this.addForm.NEXT_EFFECTIVE_DATE;
            if (this.addForm.BE_DEFAULT) {
              data.BE_DEFAULT = this.addForm.BE_DEFAULT;
            }
          }
          if (!this.addForm.NEXT_EFFECTIVE_DATE) {
            this.$message.show({ text: '请选择生效日期', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          putAway(data).then((result) => {
            this.$message.show({ text: '上架成功', type: 'success' });
            this.addProductDialog = false;
            this.handleSearch();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
    },
    getAddPriceWithoutTax(e) {
      this.addForm.PRICE_WITHOUT_TAX = (Number(e) / (1 + this.addForm.TAX_RATE / 100)).toFixed(2);
    },
    getAddNextPriceWithoutTax(e) {
      this.addForm.NEXT_PRICE_WITHOUT_TAX = (Number(e) / (1 + this.addForm.TAX_RATE / 100)).toFixed(2);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/supplierManage/addNewProduct.vue